var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MazInput',_vm._b({attrs:{"value":_vm.texto,"type":"text","inputmode":"decimal","error":!_vm.valido},on:{"input":_vm.alCambiar}},'MazInput',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }